// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VbzO","colBig":"styles_colBig__JSnhN","colSmall":"styles_colSmall__-xgJ8"};